<template>
  <div class="form-group">
    <CustomLabel
      v-if="inputLabel"
      :inputLabel="inputLabel"
      :inputId="inputId"
      :isMandatory="isMandatory"
    />
    <el-date-picker
      v-model="inputValue"
      type="datetime"
      @change="onChange"
      placeholder="YYYY-MM-DD HH:MM"
      value-format="YYYY-MM-DD HH:mm"
      :default-time="new Date(2000, 1, 1, 0, 0, 0)"
      :size="isTabletScreen ? 'small' : 'default'"
      :disabledDate="disabledDate"
      :disabled="isDisabled"
      :clearable="isClearable"
      :teleported="false"
      :editable="!IsMobileDevice"
    />
    <div v-if="isFormField">
      <Field v-model="inputValue" :id="inputId" :name="inputId" hidden />
      <ErrorMessage :name="inputId" class="validation-message" />
    </div>
  </div>
</template>

<script lang="ts">
import CustomLabel from "@/components/input/CustomLabel.vue";
import { useSessionStore } from "@/stores/sessionStore";
import { storeToRefs } from "pinia";
import { ErrorMessage, Field } from "vee-validate";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "CustomDatetimePicker",
  components: { CustomLabel, ErrorMessage, Field },
  props: {
    inputId: { type: String, required: true },
    initialValue: { type: String, default: null },
    isFormField: { type: Boolean, default: false },
    inputLabel: { type: String },
    isMandatory: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    minDate: { type: Date },
    maxDate: { type: Date },
  },

  setup(props, { emit }) {
    const sessionStore = useSessionStore();
    const { isTabletScreen, IsMobileDevice } = storeToRefs(sessionStore);
    const disabledDate = (time: Date) => {
      return (
        (props.minDate ? time.getTime() < props.minDate.getTime() : false) ||
        (props.maxDate ? time.getTime() > props.maxDate.getTime() : false)
      );
    };
    const inputValue = ref(props.initialValue);
    function onChange(date: string) {
      emit("onChange", date);
    }
    return { inputValue, isTabletScreen, IsMobileDevice, disabledDate, onChange };
  },
});
</script>
